import React from 'react';
import { Box, Column, Grid, Heading } from 'lmc-ui-library';
import { network } from 'screens/Panel/screens/Network/api';
import { HeadingWrapper, Status } from 'screens/Panel/components/DueDiligence/DueDiligancePage.styled';
import { ApprovalLine, DueDiligenceStatus } from 'screens/Panel/types/dueDiligence';
import ApproveBox from 'screens/Panel/components/DueDiligence/ApproveBox';
import { DueDiligence as DueDiligenceType } from 'utils/api/types';
import { formatDueDiligenceStatus } from 'screens/Panel/dueDiligence/formatter';
import User from 'auth/User';
import permissionService from 'routes/permissionService';
import { PAGES_ENUM, PERMISSION_ENUM } from 'routes/enums';

interface Props {
  networkId: string;
  dueDiligence: DueDiligenceType;
  reloadNetwork: any;
  user: User;
}

const DueDiligence: React.FC<Props> = ({ networkId, dueDiligence, reloadNetwork, user }) => {
  const hasFirstLinePermission = permissionService.hasPermission(
    user,
    PAGES_ENUM.ORGANIZATION_DETAILS,
    PERMISSION_ENUM.DUE_DILIGENCE_FIRST_LINE,
  );
  const hasSecondLinePermission = permissionService.hasPermission(
    user,
    PAGES_ENUM.ORGANIZATION_DETAILS,
    PERMISSION_ENUM.DUE_DILIGENCE_SECOND_LINE,
  );

  const setStatus = async (approvalLine: ApprovalLine, status: DueDiligenceStatus) => {
    if (approvalLine === ApprovalLine.FIRST) {
      await network.setFirstLineStatus(networkId, status);
      await reloadNetwork();
    }
    if (approvalLine === ApprovalLine.SECOND) {
      await network.setSecondLineStatus(networkId, status);
      await reloadNetwork();
    }
    throw new Error('Invalid line');
  };

  return (
    <Grid>
      <Column md={6} sm={12} xs={12}>
        <ApproveBox
          onUpdateStatus={setStatus}
          dueDiligence={dueDiligence}
          hasFirstLinePermissions={hasFirstLinePermission}
          hasSecondLinePermissions={hasSecondLinePermission}
        />
      </Column>
      <Column md={6} sm={12} xs={12}>
        <Box>
          <Box.Content>
            <HeadingWrapper>
              <Heading mode="subheading" variant="secondary" weight="bold">
                Network due diligence status
              </Heading>
            </HeadingWrapper>
            <Status status={dueDiligence.dd_status}>{formatDueDiligenceStatus(dueDiligence.dd_status)}</Status>
          </Box.Content>
        </Box>
      </Column>
    </Grid>
  );
};

export default DueDiligence;
